import React, { Component } from 'react';
import { connect } from 'react-redux';
import './SoeRow.css';

class SoeRow extends Component {

  formatPercent(number) {
    return (
      number !== null ? `${parseFloat(number * 100).toFixed(2)}%` : '-'
    );
  }

  render() {
    const {
      displayName,
      detailType,
      style,
      values,
    } = this.props;

    let columns = '';
    columns = values.map((value, idx) => {
      if (!value) {
        return (<td key={idx} className='textCenter'>-</td>);
      } else {
        return (
          <td key={idx} className='textCenter'>
            {this.formatPercent(value)}
          </td>
        );
      }
    });

    return (
      <tbody className='tbody func-char-soe' style={{ 'lineHeight': 1, 'borderTop': '0px' }}>
        <tr className={style === 'blue' ? 'trltGrey' : 'trWhite'}>
          <td className='textLeft'>
            <div>{displayName}</div>
          </td>
          <td className='textLeft'>
            <div>{detailType}</div>
          </td>
          {columns}
        </tr>
      </tbody >
    );
  } //render
}//class

function mapStateToProps(state) {
  return {
    data: state.fundData.data,
  };
}

export default connect(mapStateToProps, {
})(SoeRow);
